<template>
  <component
    :is="generalDataComponent"
    :asset="asset"
  />
</template>
<script>
import { assetsTypesIds } from '@/domain/data/installation/assets';
import { getKeyByValue } from '@/services/objectHelpers';
import { generalDataComponents } from '@/domain/data/installation/assetInformation/featureComponents';

export default {
  name: 'BaseGeneralData',
  props: {
    asset: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    assetTypeEnumValue() {
      return getKeyByValue(assetsTypesIds, this.asset.assetTypeId);
    },
    generalDataComponent() {
      return generalDataComponents[this.assetTypeEnumValue];
    },
  },
};
</script>
